const images = [
  { height: 1320, title: 'Exterior (Main)', url: '/storybook/property-images/1.jpeg', width: 1980 },
  {
    height: 1320,
    title: 'Exterior (Main) 2',
    url: '/storybook/property-images/2.jpeg',
    width: 1980
  },
  { height: 1320, title: 'Entrance', url: '/storybook/property-images/3.jpeg', width: 1980 },
  { height: 1320, title: 'Foyer', url: '/storybook/property-images/4.jpeg', width: 1980 },
  { height: 1320, title: 'Foyer image 2', url: '/storybook/property-images/5.jpeg', width: 1980 },
  { height: 1320, title: 'Living Room', url: '/storybook/property-images/6.jpeg', width: 1980 },
  {
    height: 1320,
    title: 'Living Room image 2',
    url: '/storybook/property-images/7.jpeg',
    width: 1980
  },
  {
    height: 1320,
    title: 'Living Room image 3',
    url: '/storybook/property-images/8.jpeg',
    width: 1980
  },
  { height: 1320, title: 'Great Room', url: '/storybook/property-images/9.jpeg', width: 1980 },
  { height: 1320, title: 'Great Room 2', url: '/storybook/property-images/10.jpeg', width: 1980 }
];

const alertPills = ['Coming Soon', 'Open House'];

export default {
  props: {
    property: {
      alertPills: alertPills,
      images
    }
  }
};
